import React from 'react';
import './TodoMenuCalendarDate.css';

interface TodoMenuCalendarDateProps {
  date?: string;
  todoBadgeStatus?: "hasTodo" | "hasExpiredTodo" | "hasTodoOnSelected" | null;
  type?: "This Month" | "Other Month" | "Today" | "Selected";
  state?: "Default" | "Hover" | "Active" | "Disabled" | "Focused";
  onClick?: () => void;
}

const TodoMenuCalendarDate: React.FC<TodoMenuCalendarDateProps> = ({
  date = "1",
  todoBadgeStatus = null,
  type = "This Month",
  state = "Default",
  onClick,
}) => {
  const getClassName = () => {
    const baseClass = "todo-calendar-date";
    const typeClass = type.toLowerCase().replace(" ", "-");
    const stateClass = state.toLowerCase();
    
    return `${baseClass} ${baseClass}--${typeClass} ${baseClass}--${stateClass}`;
  };

  return (
    <button
      className={getClassName()}
      onClick={onClick}
      disabled={state === "Disabled"}
    >
      <div className="todo-calendar-date__container">
        <div className="todo-calendar-date__state">
          <div className="todo-calendar-date__content">
            <span className="todo-calendar-date__text text-single-xlarge">
              {date}
            </span>
          </div>
          {todoBadgeStatus && (
            <div 
              className={`todo-calendar-date__badge todo-calendar-date__badge--${todoBadgeStatus.replace(/([A-Z])/g, '-$1').toLowerCase()}`}
              data-status={todoBadgeStatus}
            />
          )}
        </div>
      </div>
    </button>
  );
};

export default TodoMenuCalendarDate;
